import {
  formatDistance as dateFnsFormatDistance,
  endOfMonth,
  isThisMonth,
  setHours,
  setMilliseconds,
  setMinutes,
  setSeconds,
} from "date-fns";
import { format as dateFnsFormatTz, utcToZonedTime } from "date-fns-tz";
import { de, enGB } from "date-fns/locale";
import { isDate } from "lodash";
import { DEFAULT_LOCALE, DEFAULT_TIMEZONE } from "../constants";

const dateFnsLocales = { enGB, de };

export const format = (date, formatStr, timezone = DEFAULT_TIMEZONE) => {
  let d = date;
  if (!isDate(d)) d = utcToZonedTime(d, timezone || DEFAULT_TIMEZONE);

  return dateFnsFormatTz(d, formatStr, {
    timeZone: timezone,
    locale: dateFnsLocales[localStorage.getItem("i18nextLng") || DEFAULT_LOCALE.replace("-", "")],
  });
};

export const formatHours = (date, timezone = DEFAULT_TIMEZONE) => format(utcToZonedTime(date, timezone), "HH:mm");
export const formatDateFlat = (date, timezone = DEFAULT_TIMEZONE) => {
  return format(utcToZonedTime(date, timezone), "MMM dd yyyy");
};
export const formatMonth = (date, timezone = DEFAULT_TIMEZONE) => {
  return format(utcToZonedTime(date, timezone), "MMM, yyyy");
};
export const formatDate = (date, timezone = DEFAULT_TIMEZONE) => {
  return format(utcToZonedTime(date, timezone), "MMM dd, yyyy");
};
export const formatDateNumeric = (date, timezone = DEFAULT_TIMEZONE) => {
  return format(utcToZonedTime(date, timezone), "dd/MM/yy");
};
export const formatFullDate = (date, timezone = DEFAULT_TIMEZONE) => {
  return format(utcToZonedTime(date, timezone), "MMM dd, yyyy HH:mm");
};

export const formatDistance = (dateFrom, dateTo, timezone = DEFAULT_TIMEZONE) => {
  let [df, dt] = [dateFrom, dateTo];
  if (!isDate(df)) df = utcToZonedTime(df, timezone);
  if (!isDate(dt)) dt = utcToZonedTime(dt, timezone);

  return dateFnsFormatDistance(df, dt, {
    locale: dateFnsLocales[localStorage.getItem("i18nextLng") || DEFAULT_LOCALE.replace("-", "")],
  });
};

export const noonOfDay = (date) => setMilliseconds(setSeconds(setMinutes(setHours(date, 12), 0), 0), 0);

export const endDayOfMonth = (month) => (isThisMonth(month) ? noonOfDay(new Date()) : noonOfDay(endOfMonth(month)));
